import React from 'react';

import { Center, Stack, Text } from '@good/ui/core';
import { GroupOf3People } from '@good/illustrations';

import { BookingDrawerContentType } from './types';
import { IRosterBooking, IRosterShift } from '../bookings-roster-view/types';
import { ROSTER_TAB } from '../bookings-roster-view/components/roster-common-enums';
import { BookingDrawer } from '../bookings-roster-view/drawers/booking-drawer';
import { OpenSlotDrawer } from '../bookings-roster-view/roster-daily/components/open-slot-drawer';
import { WorkerShiftDrawer } from '../bookings-roster-view/drawers/worker-shift-drawer';

interface BookingDrawerContentProps {
  selectedRosterItem: IRosterBooking | IRosterShift | null;
  type: BookingDrawerContentType | null;
  setCanCloseDrawer: (canClose: boolean) => void;
  refreshAndCloseData: () => void;
  rosterTab: ROSTER_TAB | null;
}

export const BookingDrawerContent = ({
  selectedRosterItem,
  type,
  setCanCloseDrawer,
  rosterTab,
  refreshAndCloseData,
}: BookingDrawerContentProps) => {
  if (!selectedRosterItem || !type || !rosterTab) {
    return (
      <Center p='md'>
        <Stack align='center'>
          <GroupOf3People size='md' />
          <Text fw={550}>No booking or shift selected from calendar</Text>
        </Stack>
      </Center>
    );
  }

  switch (type) {
    case 'customerBooking':
      return (
        <BookingDrawer
          booking={selectedRosterItem as IRosterBooking}
          setCanClosePopover={setCanCloseDrawer}
          refreshAndCloseData={refreshAndCloseData}
        />
      );
    case 'workerShift':
      return (
        <WorkerShiftDrawer
          shift={selectedRosterItem as IRosterShift}
          setCanClosePopover={setCanCloseDrawer}
          refreshAndCloseData={refreshAndCloseData}
        />
      );
    case 'openSlot':
      return (
        <OpenSlotDrawer
          shift={selectedRosterItem as IRosterShift}
          setCanClosePopover={setCanCloseDrawer}
          refreshAndCloseData={refreshAndCloseData}
        />
      );
  }
};
